import { useEffect } from 'react';

import { triggerTimesheetApprovalSurvey } from '#/lib/one-flow';
import { useAnalytics } from '#/shared/hooks/useAnalytics';
import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { usePageStateStore } from '#/shared/stores/pageStateStore';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

/**
 * Hook that handles page view tracking and survey triggering based on pageState changes.
 * Triggers survey when timesheet is submitted successfully.
 */
export function usePageStateTracking(): void {
  const pageState = usePageStateStore(state => state.pageState);
  const timesheetId = useTimesheetStore(state => state.timesheet?.timesheetId);
  const { track } = useAnalytics();
  const { isEnabled: isOneFlowDisabled } = useFeatureFlag('PPL-2731-1Flow-surveys-disablement');

  // Track analytics based on pageState
  useEffect(() => {
    if (pageState === 'loading-error' || pageState === 'invalid-token') {
      track('Online approval web - View Invalid Timesheet Screen');
    }

    if (pageState === 'loading-success') {
      track('Online approval web - View Active Timesheet Screen', {
        Timesheet_ID: timesheetId || '',
        Origination_Source: 'email',
      });
    }
  }, [pageState, track, timesheetId]);

  // Trigger survey when submission is successful
  useEffect(() => {
    if (!isOneFlowDisabled && pageState === 'submission-success') {
      triggerTimesheetApprovalSurvey(timesheetId ?? '');
    }
  }, [pageState, timesheetId, isOneFlowDisabled]);
}
